module.exports = __webpack_public_path__ + "static/media/file-nodata.8692055d.png";